import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import type { FC } from "react";
import { getSupabaseClient } from "../api/supabaseClient.js";

export const DeactivatedPage: FC = () => {
  const handleSignOut = async () => {
    await getSupabaseClient().auth.signOut();
    window.location.href = "/";
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-foreground">
            Account deactivated
          </h1>
          <p className="text-gray-600">
            Your account has been deactivated by an administrator.
          </p>
          <p className="text-gray-600">
            Please reach out to your admin if you believe this is an error or if
            you need to regain access.
          </p>
        </div>
        <div className="flex justify-center pt-4">
          <Button variant={ButtonVariant.Secondary} onClick={handleSignOut}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
};
